import View from './TaxesWorkflowView';

export default View;
